import styled from 'styled-components';

export const Svg = styled.svg<{ $cursorDefault?: boolean }>`
  cursor: ${({ $cursorDefault }) => ($cursorDefault ? 'default' : 'pointer')};
  outline: none !important;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 16px;
    height: 16px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 14px;
    height: 14px;
  }
`;
